import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";

export default function TimerTile(props) {
  const { orderData, orderState, timerEnd } = props;
  const endAtTime = () => { return Math.floor((new Date(timerEnd) - new Date()) / 1000) };

  const [time, setTime] = useState(endAtTime());

  useEffect(() => {
    const interval = setInterval(() => {
      const timeEndAt = endAtTime()
      setTime(timeEndAt)
      if (timeEndAt < 0) {
        props.handleTimeOut();
        clearInterval(interval);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [timerEnd]);


  if (time < 0) { return false }

  var seconds = time % 60;
  var minutes = ((time - seconds) / 60) % 60;
  var hours = ((time - seconds - minutes * 60) / 3600);

  if (("" + seconds).length == 1) {
    seconds = "0" + seconds;
  }

  if (("" + minutes).length == 1) {
    minutes = "0" + minutes;
  }

  let timer = "";

  if (hours > 0) {
    if (("" + hours).length == 1) {
      hours = "0" + hours;
    }
    timer = `${hours}:`
  }

  if (time > 0) {
    timer += `${minutes}:${seconds}`;
  }

  return <Typography variant="timer">{timer}</Typography>

}